module.exports = __webpack_public_path__ + "img/order.31041bd5.png";